import { App } from 'antd';
import { http } from 'services/http';
import type { DocumentRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';
import { DOCUMENTS_GET_MANY } from '../query-keys.ts';

type THandleSuccessFn = (data: DocumentRes) => void;

interface IUploadDocumentMutationOptions {
  handleSuccess?: THandleSuccessFn;
}

interface IUploadDocumentVariables {
  data: FormData;
  onUploadProgress?: (event: ProgressEvent) => void;
  onSuccess?: (body: DocumentRes) => void;
}

export const useUploadDocument = (options?: IUploadDocumentMutationOptions) => {
  const { message } = App.useApp();

  return useMutationBase<DocumentRes, unknown, IUploadDocumentVariables>({
    mutationFn: async (variables) => {
      const { data, onUploadProgress, onSuccess } = variables;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const handleUploadProgress = (value: any) => {
        if (onUploadProgress) onUploadProgress({ ...value.event, percent: value.progress * 100 });
      };

      const res = await http.post<DocumentRes>('/v1/documents', data, { onUploadProgress: handleUploadProgress });

      if (onSuccess) onSuccess(res.data);
      return res.data;
    },

    invalidateCallback: () => [[DOCUMENTS_GET_MANY]],

    onSuccess: async (data) => {
      if (options?.handleSuccess) options.handleSuccess(data);

      message.success('File uploaded successfully');
    },
  });
};
